<template>
    <section style="height: 100%">
        <b-field horizontal label="filter:" class="filter">
            <b-input v-model="filter"/>
        </b-field>
        <div class="nutrition-list-container">
            <div class="nutrition-list">
                <div v-for="(item, key) of supplements" :key="supplementsKey+'_'+key">
                    <client-supplements-instruction-item :id='item.item_id' :user_id="user_id" @update="supplementsKey+=1"/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex';
    import clientSupplementsInstructionItem from './ClientSupplementsInstructionsItem';

    export default {
        name: "ClientSupplementsInstructions",
        props: {
            user_id: String,
        },
        components: {
            clientSupplementsInstructionItem,
        },
        data() {
            return {
                filter: '',
                supplementsKey: 0,
            }
        },
        created() {
            this.refresh();
        },
        methods: {
            async refresh() {
                this.filter = 'loading';
                await this.$store.dispatch('CLIENT_SUPPLEMENTS_INSTRUCTION_GET', this.user_id);
                this.filter = '';

            },
        },
        computed: {
            ...mapGetters(['getClientSupplementsInstructions']),
            supplements: {
                get() {
                    let filter = this.filter.toUpperCase();
                    let nutritions = this.getClientSupplementsInstructions
                        .filter(el => el.name.toUpperCase().indexOf(filter) > -1)
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .sort((a, b) => b.assigned - a.assigned);
                    return nutritions;
                },
            }
        },
    }
</script>

<style scoped>
    .nutrition-list-container {
        padding: 0 0 55px 0;
        margin: 0 0 -55px 0;
        height: 100%;
    }

    .nutrition-list {
        height: 100%;
        overflow-y: scroll;
        text-align: left;
        border: 1px solid lightgray;

        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                         supported by Chrome, Opera and Firefox */
    }
</style>